import { useState, useEffect } from 'react';
import { MediaDevice } from 'core/models/mediaDevice';
import { useMediaDeviceRepository } from 'services/useMediaDeviceRepository';
import { Project } from 'core/models/project';
import { Environment } from 'core/models/environment';

export enum PublishRequest {
    START, STOP
}

export function usePublishRequest(mediaDeviceId: MediaDevice.Id, projectId: Project.Id, environmentId: Environment.Id): [PublishRequest | undefined, React.Dispatch<PublishRequest | undefined>] {
    const [requesting, setRequesting] = useState<PublishRequest>();

    const repository = useMediaDeviceRepository();

    useEffect(() => {
        if (requesting === undefined) return;

        switch (requesting) {
            case PublishRequest.START:
                repository.startPublish(mediaDeviceId, projectId, environmentId);
                break;

            case PublishRequest.STOP:
                repository.stopPublish(mediaDeviceId, projectId, environmentId);
                break;
        }

    }, [environmentId, mediaDeviceId, projectId, repository, requesting]);

    return [requesting, setRequesting];
}
